import React from 'react';
import { renderDescriptionHtml } from '../utils/renderDescription';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom'
import backIcon from '../Assets/arrow-back.png'
import './DocArticle.css';
import { useEffect, useState,useRef } from 'react';
import { useSearchParams } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

function DocArticle ({code,title}) {
  const { category, id } = useParams();
    console.log("Page Route: " + category + " /  "+id)
    const navigate = useNavigate(); // Initialize useNavigate for programmatic navigation

  function nav_back (){

    if (src == "search")
   navigate(-1)
    //navigate(`/search?q=${query}`); // Navigate without reloading the page
    else
      navigate("/"+category+"?s="+s)
  }
  const [searchParams, setSearchParams] = useSearchParams();
  const s = searchParams.get("s") || "s";

  const src =searchParams.get("src")

  const divRef = useRef(null);
  const articleContainerRef = useRef(null);

  const scrollToTop = () => {
    // Accessing the current property of the ref to get the DOM node
    const divElement = divRef.current;
    // Scroll the div to the top
    if (divElement) {
      divElement.scrollTop = 0;
    }
  };

//download  categories
var categoryTitles = {}
const [content_data, setData] = useState(null);

useEffect(() => {
  if (!category || !id) return;
  const source = s || "s";
  const url = `https://api.tablemate.net/fetchDocArticles.php?category=${encodeURIComponent(category)}&id=${encodeURIComponent(id)}&s=${encodeURIComponent(source)}`;
  api.fetch(url)
    .then(async (response) => {
      const text = await response.text();
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${text.slice(0, 200)}`);
      }
      try {
        return JSON.parse(text);
      } catch {
        throw new Error("Server returned invalid JSON. Response: " + text.slice(0, 200));
      }
    })
    .then((content_data) => {
      setData(content_data);
      if (Array.isArray(content_data) && content_data.length > 0) {
        renderArticle(content_data);
      } else {
        setArticleTitle("Article not found");
        setProjectCategories(<p>No article found.</p>);
      }
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
      setArticleTitle("Error loading article");
      setProjectCategories(<p>Failed to load article. Please try again.</p>);
    });
}, [category, id, s]);

const [articleTitle, setArticleTitle] = useState("Loading...");
const [docArticle, setProjectCategories] = useState(false);

  // Mark portrait images (height > width) for max-width constraint
  useEffect(() => {
    if (!docArticle || !articleContainerRef.current) return;
    const container = articleContainerRef.current;
    const imgs = container.querySelectorAll('.doc-article img');
    const checkPortrait = (img) => {
      if (img.naturalWidth && img.naturalHeight && img.naturalHeight > img.naturalWidth) {
        img.classList.add('img-portrait');
      }
    };
    imgs.forEach((img) => {
      if (img.complete) {
        checkPortrait(img);
      } else {
        img.addEventListener('load', () => checkPortrait(img));
      }
    });
  }, [docArticle]);

const renderArticle =  (content_data) => {
  const page = renderDescriptionHtml(
    content_data[0]?.description,
    "https://admin.tablemate.net/sites/default/files"
  )
  var anArticle =content_data[0]
  setArticleTitle(anArticle.title)
  console.log("Created" + anArticle.created)
  const posterUrl = anArticle.poster_image || anArticle.posterImage
  const videoUrl = anArticle.video_url || anArticle.videoUrl
  const listArticleItems = 
      <div className="doc-article" >
        {posterUrl && (
          <div className="doc-article-poster">
            <img src={posterUrl} alt="" />
          </div>
        )}
        {videoUrl && (
          <div className="doc-article-video">
            {(() => {
              const yt = videoUrl.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([^&?/]+)/);
              const vimeo = videoUrl.match(/vimeo\.com\/(?:video\/)?(\d+)/);
              if (yt) return <iframe src={`https://www.youtube.com/embed/${yt[1]}`} title="Video" allowFullScreen frameBorder="0" />;
              if (vimeo) return <iframe src={`https://player.vimeo.com/video/${vimeo[1]}`} title="Video" allowFullScreen frameBorder="0" />;
              return <video src={videoUrl} controls poster={posterUrl || undefined} />;
            })()}
          </div>
        )}
        <div className="doc-article-body" dangerouslySetInnerHTML={{ __html: page }} />

        <hr></hr>
        <div className="doc-article-application">
          <strong>Application: </strong>{anArticle.application  != null ?  <Link className='details-link' to={`/search?q=${encodeURIComponent(anArticle.application.trim())}`}>{anArticle.application}</Link> : "Sorry, No Content"}
        </div>
        <div className="doc-article-tags">
        <hr></hr>
        <strong>Tags: </strong>
        {anArticle.tags != null &&
        (anArticle.tags.split(',').map((tag, index) => (
            <React.Fragment key={index}>
              {index > 0 && ', '} {/* Add a comma before tags except the first one */}
              <Link className='details-link' to={`/search?q=${encodeURIComponent(tag.trim())}`}>{tag.trim()}</Link>
            </React.Fragment>
          ))
        )
      }
        </div>
        <br></br>
        <div className='doc-article-date'>
          <div><strong>Created: </strong>{TimestampToDateComponent(anArticle.created)}</div>
          <div><strong>Last Updated:</strong> {TimestampToDateComponent(anArticle.changed)}</div>
        </div>
      </div>
    setProjectCategories(listArticleItems)
  return (
    
    listArticleItems
  );
return null;
};

function TimestampToDateComponent(timestamp ) {
  // Convert the Unix timestamp to milliseconds (Unix timestamp is in seconds)
  const date = new Date(timestamp * 1000);

  // Format the date into a readable string
  // You can adjust the options to suit your formatting preferences
  const formattedDate = date.toLocaleDateString("en-US", {
    weekday: 'long', // "Monday"
    year: 'numeric', // "2023"
    month: 'long', // "July"
    day: 'numeric', // "20"
  });

  return (
    formattedDate
  );
}
function capitalizeFirstLetterOfEveryWord(str) {
  return str.split(' ').map(word => 
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ');
}

  return(
    <div className="RetaurantCheckin" ref={articleContainerRef}>
      <div className="details-container-page">
      <div className='details-container-page-title'>
        <button className="back-button" onClick={nav_back}>
          <img src={backIcon} alt="Back buutton" />
        </button>
          <h3 className='detailTitle'>{articleTitle}</h3>
        </div>
       
        {docArticle}

        <p className="doc-article-support">
          For any questions/concerns please feel free to contact Table Mate Support - <Link to="/contact">Contact Us</Link>
        </p>
       
      </div>
    </div>
  );
}

export default DocArticle